import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { authApi, setAccessToken } from "../services/api";

const PartnerGuard = () => {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authApi.me();
        if (cancelled) return;
        if (res.user?.role === "partner") {
          localStorage.setItem("partnerUser", JSON.stringify(res.user));
          setStatus("ok");
        } else {
          setStatus("denied");
        }
      } catch {
        if (!cancelled) setStatus("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "loading") {
    return (
      <div className="admin-root">
        <div className="admin-loading">Checking partner session…</div>
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/partner/login" replace />;
  }

  return <Outlet />;
};

export const partnerLogout = async (navigate) => {
  try {
    await authApi.logout();
  } catch {
    /* ignore */
  }
  setAccessToken(null);
  localStorage.removeItem("partnerUser");
  navigate("/partner/login", { replace: true });
};

export default PartnerGuard;
